import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

import IconDropdownButton from './IconDropdownButton_DEPRECATED';

// This component is deprecated in favor of the <MenuButton/> from the __pds folder

const MeatballDropdownButton = ({ ariaLabel, isLoading, ...rest }) => (
  <IconDropdownButton
    ariaLabel={ariaLabel}
    className="w-10 h-10 px-4 py-0 border-solid border-gray-3"
    icon={faEllipsisV}
    isLoading={isLoading}
    size="sm"
    {...rest}
  />
);

MeatballDropdownButton.defaultProps = {
  isLoading: false,
};

MeatballDropdownButton.propTypes = {
  /**
   * ARIA label that describes the purpose of this button
   */
  ariaLabel: PropTypes.string.isRequired,
  /**
   * Whether the button is in a loading state or not
   */
  isLoading: PropTypes.bool,
};

export default MeatballDropdownButton;
